// const artistImageUrlGenerator = (pageid, size) => {
//   if (pageid && size && [80, 150, 320, '80', '150', '320'].includes(size)) {
//     return `/srv/artist-images/${pageid}/${size}.jpg`
//   } else if (pageid) {
//     return `/srv/artist-images/${pageid}/320.jpg`
//   }
//   return '/images/temp-user-cover.jpg';
// }

const cdn = 'https://zikifm.fra1.digitaloceanspaces.com';

const artistImageUrlGenerator = (pageid, size) => {
  if (pageid && size && [80, 150, 320, '80', '150', '320'].includes(size)) {
    return `${cdn}/images/artist-images/${pageid}/${size}.jpg`;
  } else if (pageid) {
    return `${cdn}/images/artist-images/${pageid}/320.jpg`;
  }
  return '/images/temp-user-cover.jpg';
};

export default artistImageUrlGenerator;
